
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M13.014 2.39l21.041 10.895a1.752 1.752 0 01.021 3.1l-7.853 4.203a3.48 3.48 0 01-3.242.023L1.945 9.71a1.752 1.752 0 01-.021-3.1l7.853-4.202a3.48 3.48 0 013.237-.02z","stroke":"#51338B","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M22.986 2.39L1.945 13.285a1.752 1.752 0 00-.021 3.1l7.853 4.203a3.48 3.48 0 003.242.023l21.036-10.9a1.752 1.752 0 00.021-3.1l-7.853-4.202a3.48 3.48 0 00-3.237-.02z","stroke":"#51338B","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31 19v6.818c0 1.28-.745 2.455-1.939 3.058l-9.338 4.717a3.847 3.847 0 01-3.446 0l-9.338-4.717C5.745 28.273 5 27.098 5 25.818V19M18 34V18","stroke":"#51338B","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    